import React from "react";
const Unauthorized = () => (
  <div style={{ textAlign: "center", padding: "100px" }}>
    <h2>Unauthorized</h2>
    <p>You do not have permission to view this page.</p>
  </div>
);
export default Unauthorized; 